module.exports = __webpack_public_path__ + "static/bg_024_basket_of_flowers-33c02edc0e496694974c7bd8bf80635d.webp";